import csi from "csi/main";
import AggregateFrom from "csi/table/AggregateFrom";
import { ViewWidget } from "csi/view/Widget";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";

	
const SRMAddProductAggregateController = declare(AggregateFrom, {

	/**
	 * @override
	 * return initial filters for popup view - if the parent is a SRM Master, then filter by the parent's lowest hierarchy level
	 */
	_getViewFilters() {
		const srMaster = this.getParent();
		const requestType = xml.enumGetText(srMaster.RequestType);

		if (requestType === "Style") {
			const masterToProductHierarchyMap = {
				SRMCollection: "Collection",
				SRMCategory2: "Category2",
				SRMCategory1: "Category1",
				SRMSeason: "ParentSeason",
			};

			const parentStructureItem = Object.entries(masterToProductHierarchyMap)
				.find(([key, value]) => xml.isValidURL(srMaster[key]));

			if (parentStructureItem) {
				const productHierarchyLevelAttr = parentStructureItem[1];
				const srMasterHierarchyLevel = this.getCache()
					.getNode(srMaster[parentStructureItem[0]]);
				return new Query()
					.Attr(xml.ATTR_NAME, xml.OP_EQUALS, srMasterHierarchyLevel.$Name, `Child:${productHierarchyLevelAttr}`)
					.getElements();
			}
		}
		return null;
	},
	
	/**
	 * Add additional filtering by Material Security Group if SRM has MSG assigned
	 * @param view
	 */
	applyActionFilters(view: ViewWidget) {
		const srMaster = this.getParent();
		const requestType = xml.enumGetText(srMaster.RequestType);
		const msg = srMaster.SRMMaterialSecurityGroup;
		if (requestType === "Material" && msg !== csi.EMPTY_URL) {
			const q = new Query().RefAttr("MaterialSecurityGroups", xml.OP_EQUALS, msg);
			if (q) {
				view.relRoot.addQuery(q);
			}
		}
		this.inherited(arguments);
	},

});

export = SRMAddProductAggregateController;